// These durations are in milliseconds
export const NotificationDuration = {
    DEFAULT: 5000,
};

const parseBooleanEnvValue = (value, defaultValue = true) => {
    if (typeof value !== "string") {
        return defaultValue;
    }

    const normalized = value.trim().toLowerCase();

    if (["true", "1", "yes", "on"].includes(normalized)) {
        return true;
    }

    if (["false", "0", "no", "off"].includes(normalized)) {
        return false;
    }

    return defaultValue;
};

const rawChatEnabled =
    process.env.CHAT_ENABLED ?? process.env.REACT_APP_CHAT_ENABLED;

export const MASTER_CONFIG = {
    chat_enabled: parseBooleanEnvValue(rawChatEnabled, true),
};
